import { render, staticRenderFns } from "./prodspc.vue?vue&type=template&id=025b08d5&"
import script from "./prodspc.vue?vue&type=script&lang=js&"
export * from "./prodspc.vue?vue&type=script&lang=js&"
import style0 from "./prodspc.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports